import { CART_ICONS } from '~constants/icons';
import { TEMPLATE_MODELS } from '~constants/templates';

export const TEMPLATE_MODEL_CONFIG = {
  [TEMPLATE_MODELS.SUSHI]: {
    hasItemsLabel: false,
    show0Quantity: false,
    cartIcon: CART_ICONS.bag
  },
  [TEMPLATE_MODELS.GENERIC]: {
    hasItemsLabel: true,
    show0Quantity: true,
    cartIcon: CART_ICONS.bag
  },
  [TEMPLATE_MODELS.BURGERS]: {
    hasItemsLabel: true,
    show0Quantity: true,
    cartIcon: CART_ICONS.cart
  }
};
